import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../login/data-access/auth.service';
import { map } from 'rxjs';
import { AgreementService } from '../data-access/agreement.service';

/*
 * This guard is used to redirect the user to the appropriate page
 * if they have not yet accepted the required or optional agreements.
 *
 */

export const optionalAgreementsGuard = () => {
  const agreementService = inject(AgreementService);
  const router = inject(Router);

  return agreementService.listOptionalAgreements().pipe(
    map((newAgreements) => {
      if (
        newAgreements.length > 0 ||
        agreementService.optionalAgreements.length > 0
      ) {
        agreementService.optionalAgreements = [
          ...agreementService.optionalAgreements,
          ...newAgreements,
        ];
        agreementService.nextOptionalAgreements$.next(
          agreementService.optionalAgreements
        );
        return router.parseUrl('/login/research');
      }
      return true;
    })
  );
};
